// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__UKp3K","header":"PatientBlock_header__1xdc6","label":"PatientBlock_label__9xe7K","option":"PatientBlock_option__2rML1"};